export const GAME_NAME = "Keno";
export const APP_STORAGE_ID = GAME_NAME.split(" ").join("_") + "_store";
export const ENABLE_LOGGING = false;

export enum eGlobalState {
  IDLE = "Idle",
  SPIN_START = "SpinStart",
  SPIN_RUN = "SpinRun",
  SPIN_END = "SpinEnd",
  REEL_MOD_START = "ReelModifierStart",
  REEL_MOD_RUN = "ReelModifierRun",
  REEL_MOD_END = "ReelModifierEnd",
  WIN_PREVIEW_START = "WinPreviewStart",
  WIN_PREVIEW_END = "WinPreviewEnd",
  WINLINES_LOOP = "WinLinesLoop",
  FEATURE_START = "FeatureStart",
  FEATURE_RUN = "FeatureRun",
  FEATURE_END = "FeatureEnd",
  COLLECT = "Collect",
  FEATURE_FREE_END = "FeatureFreeEnd",
}

/** Modal Menus Configuration */
export enum MENU_POPUPS {
  POPUP_OK = "POPUP_OK", // expects fields strTitle and strText in payload
  POPUP_RELOAD = "POPUP_RELOAD",

  POPUP_BET = "POP_BET",
  POPUP_SUCCESS = "POPUP_SUCCESS",

  ZERO_FUNDS_WINDOW = "ZERO_FUNDS_WINDOW",
  INSUFFICIENT_FUNDS_WINDOW = "INSUFFICIENT_FUNDS_WINDOW",
  RESPONSIBLE_GAMING_EXCEEDED = "RESPONSIBLE_GAMING_EXCEEDED",
  RESPONSIBLE_GAMING_BLOCK = "RESPONSIBLE_GAMING_BLOCK",
  COULD_NOT_PLACE_BET = "COULD_NOT_PLACE_BET",

  POPUP_INSURANCE = "POPUP_INSURANCE",

  // popup used to show critical errors (lets you only reload the game)
  ERROR_POPUP_CRITICAL = "ERROR_POPUP_CRITICAL",
  // popup used to show critical errors (no button)
  ERROR_POPUP_CRITICAL_NOINPUT = "ERROR_POPUP_CRITICAL_NOINPUT",
  ERROR_POPUP_CRITICAL_WS_DISCONNECT = "ERROR_POPUP_CRITICAL_WS_DISCONNECT",
  // popup used to show warnings (lets you continue)
  ERROR_POPUP_WARNING = "ERROR_POPUP_WARNING",

  POPUP_RESULTS = "POPUP_RESULTS",
}

export const GAME_SOUNDS = new Map<string, string>();
GAME_SOUNDS.set("BALL_MISS", "small-short-deep-whoosh.mp3");
GAME_SOUNDS.set("BALL_MATCH", "fast-deep-cinematic-whoosh-swo.mp3");

/** Reels && Slots */
export const NO_OF_ITEMS = 10;
export const NO_OF_ROWS = 5;
export const NO_TOTAL_NUMBERS = 80;

/** Onboarding Screen Options */
export const MAX_ONBOARDING_PAGES = 3;

export const NO_OF_DRAWS = [1, 2, 3, 5, 10, 20, 50];

export const Y_DISTANCE = 12.5;
export const X_DISTANCE = 10;
export const TOP_DISTANCE = 0;

export const MAX_RANDOM_NUMBERS = 10;
export const MAX_NUMBER = 80;

export const ALLOWED_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 40];

export const BETTING_OPEN_SECONDS = 5;
export const RESULTS_POPUP_CLOSE_DEELAY = 3500;

export const KENO_GAME_TYPE = "CLASSIC";
